import React from 'react'
import { useTheme } from '@opallabs/hooks'
import * as styles from './styles'

type RowProps = {
  size: 'short' | 'tall'
  percentWidth: number
}

const Row: React.FC<RowProps> = ({ size, percentWidth }) => {
  const theme = useTheme()
  return <div css={styles.row(size, percentWidth, theme)} />
}

export const ShimmerTextPlaceholder: React.FC = () => {
  return (
    <div css={styles.container} className="shimmer-text-placeholder">
      <Row size="tall" percentWidth={81} />
      <Row size="short" percentWidth={95} />
      <Row size="short" percentWidth={91} />
      <Row size="short" percentWidth={100} />
      <Row size="short" percentWidth={43} />
    </div>
  )
}
